var map = {
	"./bd.svg": "63a8",
	"./bianji.svg": "7020",
	"./delete.svg": "a3dd",
	"./edit.svg": "2fb0",
	"./fold.svg": "8720",
	"./logo-title.svg": "8d8a",
	"./logo.svg": "d9b6",
	"./pxgl.svg": "898d",
	"./qxgl.svg": "a708",
	"./rwgl.svg": "bd1b",
	"./test.svg": "90e6",
	"./unfold.svg": "2f20",
	"./upload.svg": "068c",
	"./xiazai.svg": "dc61",
	"./yysgl.svg": "a3d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";